<main>
    <div class="activities_left">
        <app-menus></app-menus>
    </div>
    <div class="activities_right">
        <div class="home_bg"></div>
        <div *ngFor="let activity of activitess" style="background-color: #{{activity.bgColor}}" class="activity_card">
            <p >{{activity.activiteName}}</p>
            <button *ngIf="activity.bgColor == '2949a8'" style="background-color: #D4AB16;" (click)="this.app.navigateTo('/activites/jeux/'+ activity.id + '-' + activity.bgColor)">jouer</button>
            <button *ngIf="activity.bgColor == 'D4AB16'" style="background-color: #2949a8;" (click)="this.app.navigateTo('/activites/jeux/'+ activity.id + '-' + activity.bgColor)">jouer</button>
          </div>
    </div>
</main>